var ProductServicesComponent = Vue.component('product-services', {
    props: ['productId'],
    data: function () {
        return {
            loaded: false,
            serviceGroups: []
        }
    },
    created: function() {
        $(function() {
            this.fetch('post', 'rshop-api/products/services', { product_id: this.productId }, function (response) {
                this.serviceGroups = response.result.services;
                this.loaded = true;

                rEvent.dispatch('ProductServices.loaded');
            }.bind(this));
        }.bind(this));
    },
    methods: {
        processService: function ($event, serviceGroup) {
            var $input = $($event.target),
                $serviceInputs = $('input[name="services[]"]');

            $serviceInputs.prop('disabled', true);
            if (serviceGroup.single_item && $input.is(':checked')) {
                $serviceInputs
                    .filter('[data-service-group-id="' + serviceGroup.id + '"]:checked')
                    .not($event.target)
                    .prop('checked', false);
            }

            this.fetch('post', '/process-service/' + this.productId, { product_id: this.productId, service_id: $input.val(), bind: $input.is(':checked') ? 1 : 0}, function(response) {
                $serviceInputs.prop('disabled', false);
                this.$store.dispatch('fetchCartTotals');
            }.bind(this), 'json');
        }
    },
    computed: {
        isEmpty: function() {
            return this.serviceGroups.length == 0;
        }
    }
});
